import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-050ff4ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "senior_worp" }
const _hoisted_2 = { class: "senior_worp_left_type" }
const _hoisted_3 = { class: "left_pc_bor" }
const _hoisted_4 = {
  key: 1,
  class: "senior_worp_left_mobile"
}
const _hoisted_5 = { class: "senior_worp_right" }
const _hoisted_6 = { class: "worp_right_title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "worp_right_content" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content_item_box" }
const _hoisted_11 = { class: "content_item_title" }
const _hoisted_12 = { class: "content_item_col" }
const _hoisted_13 = { class: "content_item_slider" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content_item_slider_span" }, "不透明度：", -1))
const _hoisted_15 = { class: "content_item_right" }
const _hoisted_16 = { class: "content_item_img" }
const _hoisted_17 = {
  key: 0,
  class: "img_box"
}
const _hoisted_18 = { class: "img_hover" }
const _hoisted_19 = {
  key: 1,
  class: "img"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "content_item_icon" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "" }, "点击或将图片拖至此区域", -1))
const _hoisted_25 = { class: "measurement" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "content_gird" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "item_select_arrow" }
const _hoisted_30 = { class: "gird_item_box" }
const _hoisted_31 = { class: "gird_item_top" }
const _hoisted_32 = { class: "gird_hover" }
const _hoisted_33 = { class: "gird_hover_con" }
const _hoisted_34 = { class: "btn_action" }
const _hoisted_35 = { class: "btn_action_box" }
const _hoisted_36 = { class: "gird_item_top_box" }
const _hoisted_37 = { class: "gird_item_top_img" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "gird_item_name" }
const _hoisted_40 = {
  key: 0,
  class: "gird_item_txt"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "worp_right_btn" }
const _hoisted_43 = {
  key: 0,
  class: "worp_right_btn_s"
}
const _hoisted_44 = {
  key: 1,
  class: "worp_right_btn_m"
}
const _hoisted_45 = { class: "btn_m_box" }
const _hoisted_46 = { class: "worp_right_btn_nav" }
const _hoisted_47 = { class: "model_box" }

import { message, Radio, Slider, Upload, Checkbox, Image, Modal } from 'ant-design-vue';
import {
  reactive,
  ref,
  defineAsyncComponent,
  unref,
  watch,
  computed,
  nextTick,
  createVNode,
} from 'vue';
import { ElColorPicker } from 'element-plus';
import {
  RedoOutlined,
  LoadingOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  DeleteOutlined,
  UpOutlined,
  RightOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue';
import { ModalData, FileInfo, PcStyleSet, StyleList, PcTemplate } from './type';
import http from '@/api/pagedirect';
import { useRoute } from 'vue-router';
import { getToken } from '@/plugins/cookie';
import domtoimage from 'dom-to-image';
import { RootModal } from '@/components/CDelModal.vue';
import { emptyDataSec } from '@/assets';
import CLoading from '@/components/CLoading.vue';
import CDelModalVue from '@/components/CDelModal.vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { useLiveStore } from '@/pinia/live';
import { FileItem } from '@/components/CUpload.vue';

interface IProps {
  modelValue: ModalData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SeniorSet',
  props: {
    modelValue: null
  },
  emits: ['updata:data', 'refresh'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  modelValue: ModalData;
};

const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);
const PreviewPc = defineAsyncComponent(() => import('./PreviewPc.vue'));
const PreviewMobile = defineAsyncComponent(() => import('./PreviewMobile.vue'));
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aSlider = Slider;
const aUploadDragger = Upload.Dragger;
const aCheckbox = Checkbox;
const aImage = Image;
const aModal = Modal;
const route = useRoute();
const meauKey = ref(1);
const meauList = reactive([
  { key: 1, title: '样式设置' },
  { key: 2, title: '模板库' },
]);

const preview = ref('1');

const meauTabs = (key: number) => {
  meauKey.value = key;
  if (key === 2) {
    pageConfigure.current = 1;
    PcTemplateList.value = [];
    getTemplate();
  }
};

const colorList = ref(['#00CCb0', '#1890FF', '#FF4D4F', '#FF9337']);

const styleList = ref<StyleList[]>([
  {
    key: 0,
    title: '导航栏背景',
    type_name: 'navigation',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
    fileList: [],
    loading: false,
    showUrl: false,
  },
  {
    key: 1,
    title: 'Tab栏背景',
    type_name: 'tab_bar',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
    fileList: [],
    loading: false,
    showUrl: false,
  },
  {
    key: 2,
    title: '聊天室背景',
    type_name: 'chat_room',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
    fileList: [],
    loading: false,
    showUrl: false,
  },
  {
    key: 3,
    title: '内容栏背景',
    type_name: 'content_bar',
    bg_color: '#FFFFFF',
    opacity: 100,
    image_url: '',
    fileList: [],
    loading: false,
    showUrl: false,
  },
]);

const sizeList = ['1920 * 80', '330 * 40', '330 * 480', '970 * 40'];


const dataSource = ref<ModalData>({
  topShow: false,
  titleColor: '',
  topBbColor: '',
  logoUrl: '',
  videoCv: '',
  themeColor: '',
  pcBgColor: '',
  pcBgUrl: '',
  textColor1: ' ',
  textColor2: ' ',
  tabBgColor: '',
  pc_botton_bg: '',
  msgBgColor: '',
  sendBgColor: '',
  menuBgColor: '',
  tabTitleColor: '',
  msgColor: '',
  sendColor: '',
  type: '0',
  mobile_bg: '',
  mobile_meau_bg: '',
  mobile_meau_color: '',
  mobile_send_bg: '',
});
dataSource.value = unref(props.modelValue);

watch(
  () => props.modelValue.allKey,
  () => {
    styleList.value[0].image_url =
      styleList.value[1].image_url =
      styleList.value[2].image_url =
      styleList.value[3].image_url =
      dataSource.value.pc_top_bgimg =
      dataSource.value.pc_tab_bgimg =
      dataSource.value.pc_msg_bgimg =
      dataSource.value.mobile_msg_bgimg =
      dataSource.value.pc_meau_bgimg =
      dataSource.value.mobile_tab_bgimg =
        '';
  }
);
watch(
  () => props.modelValue,
  () => {
    dataSource.value = unref(props.modelValue);
    if (props.modelValue?.type === '2') styleList.value[2].image_url = process.env.VUE_APP_OTHER_LINK+'/ab4c720220722133615203.png';
    init();
  }
);

// 获取样式颜色
const init = () => {
  styleList.value.forEach((e, i) => {
    e.image_url = dataSource.value.styleList[i].image_url;
    e.opacity = dataSource.value.styleList[i].opacity;
  });
  styleList.value[0].bg_color = dataSource.value.topBbColor;
  if (dataSource.value.pc_msg_bgimg) {
    styleList.value[2].image_url = dataSource.value.pc_msg_bgimg;
  }
  if (props.modelValue.type === '3') {
    styleList.value[2].bg_color = styleList.value[1].bg_color = '#016891';
    dataSource.value.mobile_bg = dataSource.value.msgBgColor = 'linear-gradient(138deg, #065b80 0%, #061e43 51%, #035c82 100%)';
    dataSource.value.tabBgColor = dataSource.value.mobile_meau_bg = 'linear-gradient(132deg, #0a81a9 0%, #0a4367 100%)';
  } else {
    styleList.value[1].bg_color = dataSource.value.tabBgColor;
    styleList.value[2].bg_color = dataSource.value.msgBgColor;
    if (props.modelValue.type === '0') '#FFFFFF';
  }
  styleList.value[3].bg_color = dataSource.value.menuBgColor;
};

// 获取数据
const getPCStyles = () => {
  init();
  const data = { studio_id: route.params.studioId };
  http.getDecorate({ params: data }).then((res) => {
    const resDataPc: PcStyleSet = res.data.data.style_settings;
    dataSource.value.pcBgColor = res.data.data.bg_color;
    nextTick(() => {
      styleList.value.forEach((e, i) => {
        if (resDataPc[i].type_name) e.type_name = resDataPc[i].type_name;
        if (resDataPc[i].bg_color) e.bg_color = resDataPc[i].bg_color;
        e.opacity = Number(resDataPc[i].opacity);
        if (resDataPc[i].image_url) e.image_url = resDataPc[i].image_url;
        pickerPc(i);
        updataImg(e);
        hyalinePc(i);
      });
    });
    emit('updata:data', dataSource.value, res.data.data.style_settings);
  });
};
getPCStyles();

expose({ getPCStyles });
const openShowUrl = (item: StyleList) => {
  item.showUrl = !item.showUrl;
};

const beforeUpload = (file: FileItem) => {
  const isJpgOrPng =
    file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif';
  if (!isJpgOrPng) {
    message.error('上传图片的格式有误!');
  }
  return isJpgOrPng;
};

const handleChange = (info: FileInfo, item: StyleList) => {
  if (info.file.response.code === 100) {
    item.loading = false;
    message.error(info.file.response.error);
  }
  if (info.file?.response?.code === 200) {
    item.image_url = info.file?.response?.data.url;
    updataImg(item);
  }
  if (info.file.status === 'uploading') {
    item.loading = true;
    return;
  } else item.loading = false;
};

const updataImg = (item: StyleList) => {
  // nextTick(() => {
  switch (item.key) {
    case 0:
      dataSource.value.pc_top_bgimg = styleList.value[0].image_url = item.image_url;
      break;
    case 1:
      dataSource.value.pc_tab_bgimg = dataSource.value.mobile_tab_bgimg = styleList.value[1].image_url = item.image_url;
      break;
    case 2:
      dataSource.value.pc_msg_bgimg = dataSource.value.mobile_msg_bgimg = styleList.value[2].image_url = item.image_url;
      break;
    case 3:
      dataSource.value.pc_meau_bgimg = styleList.value[3].image_url = item.image_url;
      break;
  }
  // });
};

const clearClick = (item: StyleList) => {
  item.image_url = '';
  switch (item.key) {
    case 0:
      dataSource.value.pc_top_bgimg = '';
      break;
    case 1:
      dataSource.value.pc_tab_bgimg = dataSource.value.mobile_tab_bgimg = '';
      break;
    case 2:
      dataSource.value.pc_msg_bgimg = dataSource.value.mobile_msg_bgimg = '';
      break;
    case 3:
      dataSource.value.pc_meau_bgimg = '';
      break;
  }
};

// 修改颜色
const pickerPc = (index: number) => {
  // nextTick(() => {
  switch (index) {
    case 0:
      dataSource.value.topBbColor = styleList.value[index].bg_color;
      break;
    case 1:
      dataSource.value.tabBgColor = dataSource.value.mobile_meau_bg = styleList.value[index].bg_color;
      if (styleList.value[index].bg_color === '#016891')
        dataSource.value.tabBgColor = dataSource.value.mobile_meau_bg = 'linear-gradient(132deg, #0a81a9 0%, #0a4367 100%)';
      break;
    case 2:
      dataSource.value.msgBgColor = dataSource.value.mobile_bg = styleList.value[index].bg_color;
      if (styleList.value[index].bg_color === '#016891')
        dataSource.value.msgBgColor = dataSource.value.mobile_bg =
          'linear-gradient(138deg, #065b80 0%, #061e43 51%, #035c82 100%)';
      break;
    case 3:
      dataSource.value.menuBgColor = styleList.value[index].bg_color;
      break;
  }
  // });
};

// 修改透明度
const hyalinePc = (index: number) => {
  switch (index) {
    case 0:
      dataSource.value.opacity_pc_0 = Number(styleList.value[index].opacity / 100);
      break;
    case 1:
      dataSource.value.opacity_pc_1 = dataSource.value.opacity_mobile_0 = Number(styleList.value[index].opacity / 100);
      break;
    case 2:
      dataSource.value.opacity_pc_2 = dataSource.value.opacity_mobile_1 = styleList.value[index].opacity / 100;
      break;
    case 3:
      dataSource.value.opacity_pc_3 = styleList.value[index].opacity / 100;
      break;
  }
};

const reaetData = (item: StyleList, index: number) => {
  const colorList0 = ['#FFFFFF', '#FFFFFF', '#F7F9FC', '#FFFFFF'];
  const colorList1 = ['#192431', '#232F3B', '#121B25', '#232F3B'];
  const colorList2 = ['#D82737', '#D82737', '#CA2433', '#D82737'];
  const colorList3 = ['#002C50', '#016891', '#016891', '#0A486C'];
  const colorList4 = ['#0A1626', '#162231', '#0A1626', '#162231'];

  item.opacity = 100;
  item.image_url = '';
  switch (dataSource.value.type) {
    case '1':
      item.bg_color = colorList1[index];
      break;
    case '2':
      item.bg_color = colorList2[index];
      if (index === 2) item.image_url = process.env.VUE_APP_OTHER_LINK+'/ab4c720220722133615203.png';
      break;
    case '3':
      item.bg_color = colorList3[index];
      break;
    case '4':
      item.bg_color = colorList4[index];
      break;
    default:
      item.bg_color = colorList0[index];
      break;
  }
  pickerPc(index);
  updataImg(item);
  hyalinePc(index);
  //
};

const createModal = reactive<RootModal>({
  title: '模板创建',
  visible: false,
  loading: false,
});

const openCreateModal = () => {
  createModal.visible = !createModal.visible;
};
const templateRef = ref();
const libraryPc = ref(); //PC预览页面图片
const saveLibrary = () => {
  openCreateModal();
  domtoimage
    .toPng(templateRef.value)
    .then((dataUrl) => {
      libraryPc.value = dataUrl;
    })
    .catch((err) => console.log(err));
};
// 存储到模板库
const librartName = ref('');
const handleOk = () => {
  const resData = styleList.value.map((e) => new PcStyleSet(e));
  let data = {
    name: librartName.value,
    style_info: JSON.stringify(resData),
    preview_image: libraryPc.value,
    dark_mode: dataSource.value.type,
    theme_color: dataSource.value.themeColor,
    image_bg_id: dataSource.value.image_id,
    bg_color: dataSource.value.color_ke,
    is_cover: 0,
  };
  http
    .saveToTemplate(data)
    .then((res) => {
      message.success(res.data.message);
      librartName.value = '';
      openCreateModal();
    })
    .catch((err) => {
      if (err.data.error !== '模板已存在') {
        message.error(err.data.error);
      } else {
        Modal.confirm({
          title: () => '模板库已有该名称模板，是否覆盖?',
          icon: () => createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            data.is_cover = 1;
            http.saveToTemplate(data).then((res) => {
              message.success(res.data.message);
              librartName.value = '';
              openCreateModal();
            });
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    });
  //
};

const deletes = ref(false);
const openDeletes = () => {
  deletes.value = !deletes.value;
};
const ConfirmDelete = async () => {
  try {
    const data = {
      studio_id: route.params.studioId,
      dark_mode: dataSource.value.type,
      theme_color: dataSource.value.themeColor,
      bg_color: dataSource.value.color_ke,
      is_clear: 1,
    };
    let bgColor = { studio_id: route.params.studioId, bg_color: dataSource.value.color_ke };
    let imageBg = { studio_id: route.params.studioId, image_bg_id: dataSource.value.image_id };
    await http.updataStreamTheme(data);
    await http.getStreamThemeBgColor(bgColor);
    await http.getStreamThemeImageBg(imageBg);
    setPcDecorate();
    openDeletes();
  } catch (err: any) {
    console.error(err?.data?.error);
  }
};

const is_Mode = computed(() => liveInfo.value.mode === 4 && liveInfo.value.studio_pid === liveInfo.value.id);

// pc 保存
const clickStyle = useDebounce(() => {
  // if (liveInfo.value.mode !== 4 || (liveInfo.value.mode == 4 && liveInfo.value.studio_pid !== liveInfo.value.id)) {
  if (is_Mode.value) {
    openDeletes();
  } else {
    setPcDecorate();
  }
  // }
});

const setPcDecorate = () => {
  emit('refresh', false);
  const resData = styleList.value.map((e) => new PcStyleSet(e));
  let data = {
    studio_id: route.params.studioId,
    style_settings: JSON.stringify(resData),
    dark_mode: dataSource.value.type,
    theme_color: dataSource.value.themeColor,
    image_bg_id: dataSource.value.image_id,
    bg_color: dataSource.value.color_ke,
  };
  http
    .setPcDecorate(data)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};
// 获取模板库
const PcTemplateList = ref<PcTemplate[]>([]);
// 分页
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
});
const getTemplate = () => {
  const data = { page: pageConfigure.current, page_num: pageConfigure.pageSize };
  http
    .getTemplateList({ params: data })
    .then((res) => {
      const resData = res.data.data;
      pageConfigure.totalSize = resData.total;
      PcTemplateList.value = PcTemplateList.value.concat(resData.data);
      PcTemplateList.value.forEach((e) => (e.showInput = false));
      selectKeys.value = {};
      resData.data.map((e: PcTemplate) => {
        selectKeys.value[e.id] = false;
      });
    })
    .catch((err) => message.error(err.data.error));
};
const scrollEventPc = () => {
  // 滚动条距离顶部的距离 + // 滚动条外容器的高度 >=   滚动条高度
  if (pageConfigure.totalSize && PcTemplateList.value.length < pageConfigure.totalSize) {
    pageConfigure.current = pageConfigure.current + 1;
    getTemplate();
  }
};
// onMounted(() => {
//   heightRef.value.addEventListener('scroll', scrollEvent);
// });
// 应用
const useButton = useDebounce((item: PcTemplate) => {
  // nextTick(() => {
  dataSource.value.topBbColor = styleList.value[0].bg_color = item.style_info[0].bg_color;
  dataSource.value.opacity_pc_0 = (styleList.value[0].opacity = item.style_info[0].opacity) / 100;

  dataSource.value.mobile_meau_bg = dataSource.value.tabBgColor = styleList.value[1].bg_color = item.style_info[1].bg_color;
  dataSource.value.opacity_mobile_0 = dataSource.value.opacity_pc_1 =
    (styleList.value[1].opacity = item.style_info[1].opacity) / 100;

  dataSource.value.mobile_bg = dataSource.value.msgBgColor = styleList.value[2].bg_color = item.style_info[2].bg_color;
  styleList.value[2].image_url = item.style_info[2].image_url;
  dataSource.value.pc_msg_bgimg = dataSource.value.mobile_msg_bgimg = item.style_info[2].image_url;
  nextTick(() => {
    dataSource.value.mobile_tab_bgimg =
      dataSource.value.pc_tab_bgimg =
      styleList.value[1].image_url =
        item.style_info[1].image_url;
    dataSource.value.pc_meau_bgimg = styleList.value[3].image_url = item.style_info[3].image_url;
    dataSource.value.pc_top_bgimg = styleList.value[0].image_url = item.style_info[0].image_url;
  });
  dataSource.value.opacity_mobile_1 = dataSource.value.opacity_pc_2 =
    (styleList.value[2].opacity = item.style_info[2].opacity) / 100;

  dataSource.value.menuBgColor = styleList.value[3].bg_color = item.style_info[3].bg_color;
  dataSource.value.opacity_pc_3 = (styleList.value[3].opacity = item.style_info[3].opacity) / 100;

  dataSource.value.type = item.dark_mode.toString();
  dataSource.value.themeColor = item.theme_color;
  dataSource.value.pcBgUrl = item.image_bg_url;
  dataSource.value.pcBgColor = item.bg_color;
  dataSource.value.image_id = item.image_bg_id;
  emit('updata:data', dataSource.value);
  // });
});

// 选择
const selectAll = ref(false);
// 筛选标记
const selectKeys = ref({});
const changeItemMarkAll = () => {
  if (selectAll.value === true) {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k, index) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeItemMark = (item: PcTemplate) => {
  if (selectAll.value) selectKeys.value[item.id] = !selectKeys.value[item.id];
};
const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr.join(',');
});
const getSelected = computed(() => Boolean(!getSelectIds.value));
// 删除模板
const delModal = reactive<RootModal>({
  title: '删除',
  visible: false,
  loading: false,
});
const delId = ref();
const delType = ref();
const openDelModal = (type: number, id?: number) => {
  delType.value = type;
  if (id) delId.value = id;
  delModal.visible = true;
};
const closeDelModal = () => {
  delModal.visible = false;
};
const delClick = () => {
  let data = {};
  if (delType.value === 1) {
    data = {
      id: delId.value,
    };
  }
  if (delType.value === 2) {
    data = {
      id: getSelectIds.value,
    };
  }
  http
    .delTemplate(data)
    .then((res) => {
      message.success(res.data.message);
      closeDelModal();
      pageConfigure.current = 1;
      PcTemplateList.value = [];
      getTemplate();
      selectAll.value = false;
      delType.value = '';
      delId.value = '';
    })
    .catch((err) => message.error(err.data.error));
};

const clickShowInput = (item: PcTemplate) => {
  item.showInput = !item.showInput;
};

const onBlur = (item: PcTemplate) => {
  http
    .setTemplateName({ name: item.name, id: item.id })
    .then((res) => {
      message.success(res.data.message);
      item.showInput = false;
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["senior_worp_left", { senior_worp_left: preview.value === '1' }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 预览： "),
        _createVNode(_unref(aRadioGroup), {
          name: "radioGroup",
          value: preview.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((preview).value = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (meauKey.value = 1))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), { value: "1" }, {
              default: _withCtx(() => [
                _createTextVNode("PC预览页面")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: "2" }, {
              default: _withCtx(() => [
                _createTextVNode("手机预览页面")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (preview.value === '1')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "templateRef",
            ref: templateRef,
            class: "senior_worp_left_pc"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(PreviewPc), {
                modelValue: dataSource.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataSource).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ], 512))
        : _createCommentVNode("", true),
      (preview.value === '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(PreviewMobile), {
              modelValue: dataSource.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dataSource).value = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meauList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: _normalizeClass(["worp_right_tap", { actived: meauKey.value === item.key }]),
            onClick: ($event: any) => (meauTabs(item.key))
          }, _toDisplayString(item.title), 11, _hoisted_7))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(styleList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content_item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(item.title) + "：", 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(item.bg_color) + " ", 1),
                  _createVNode(_unref(ElColorPicker), {
                    modelValue: item.bg_color,
                    "onUpdate:modelValue": ($event: any) => ((item.bg_color) = $event),
                    predefine: colorList.value,
                    size: "mini",
                    onChange: ($event: any) => (pickerPc(index))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "predefine", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_unref(aSlider), {
                    value: item.opacity,
                    "onUpdate:value": ($event: any) => ((item.opacity) = $event),
                    onChange: ($event: any) => (hyalinePc(index))
                  }, null, 8, ["value", "onUpdate:value", "onChange"]),
                  _createTextVNode("    "),
                  _createElementVNode("div", null, _toDisplayString(item.opacity) + "%", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_button, {
                  class: _normalizeClass(["content_item_btn", { show: item.showUrl }]),
                  onClick: ($event: any) => (openShowUrl(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 添加图片 "),
                    (item.showUrl)
                      ? (_openBlock(), _createBlock(_unref(UpOutlined), {
                          key: 0,
                          style: { fontSize: '10px', marginLeft: '3px' }
                        }))
                      : (_openBlock(), _createBlock(_unref(RightOutlined), {
                          key: 1,
                          style: { fontSize: '10px', marginLeft: '3px' }
                        }))
                  ]),
                  _: 2
                }, 1032, ["onClick", "class"]),
                _createVNode(_component_a_button, {
                  class: "content_item_btn",
                  onClick: ($event: any) => (reaetData(item, index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置"),
                    _createVNode(_unref(RedoOutlined))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(aUploadDragger), {
                  fileList: item.fileList,
                  "onUpdate:fileList": ($event: any) => ((item.fileList) = $event),
                  name: "images",
                  "show-upload-list": false,
                  accept: ".jpg,.jpeg,.png,.gif",
                  headers: { token: _unref(getToken)() },
                  action: "/api/v1/common/upload_images",
                  "before-upload": beforeUpload,
                  onChange: (info) => handleChange(info, item)
                }, {
                  default: _withCtx(() => [
                    (item.image_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_unref(PlusCircleOutlined)),
                            _createVNode(_unref(DeleteOutlined), {
                              onClick: _withModifiers(($event: any) => (clearClick(item)), ["stop"])
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.image_url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("img", {
                            src: item.image_url
                          }, null, 8, _hoisted_20)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (item.loading)
                            ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("p", _hoisted_23, [
                                  _createVNode(_unref(PlusCircleFilled))
                                ]),
                                _hoisted_24
                              ]))
                        ]))
                  ]),
                  _: 2
                }, 1032, ["fileList", "onUpdate:fileList", "headers", "onChange"])
              ], 512), [
                [_vShow, item.showUrl]
              ]),
              _createElementVNode("div", _hoisted_25, "建议尺寸：" + _toDisplayString(sizeList[index]), 1)
            ]))
          }), 128))
        ], 512), [
          [_vShow, meauKey.value === 1]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PcTemplateList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["gird_item", { item_select: selectAll.value, item_selected: selectKeys.value[item.id] }]),
                key: index,
                onClick: ($event: any) => (changeItemMark(item))
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_svg_icon, {
                    class: "item_select_arrow_icon",
                    "icon-class": "checked"
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_a_button, {
                          class: "content_item_btn",
                          onClick: ($event: any) => (_unref(useButton)(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("应用")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_svg_icon, {
                              "icon-class": "pageDirector_see",
                              class: "icon"
                            }),
                            _createVNode(_unref(aImage), {
                              src: item.preview_image,
                              class: "btn_read"
                            }, null, 8, ["src"]),
                            _createVNode(_component_svg_icon, {
                              "icon-class": "pageDirector_del",
                              class: "icon",
                              onClick: ($event: any) => (openDelModal(1, item.id))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        (item.preview_image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.preview_image
                            }, null, 8, _hoisted_38))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    (!item.showInput)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(item.name), 1))
                      : _createCommentVNode("", true),
                    (item.showInput)
                      ? (_openBlock(), _createBlock(_component_a_input, {
                          key: 1,
                          value: item.name,
                          "onUpdate:value": ($event: any) => ((item.name) = $event),
                          size: "small",
                          class: "gird_item_in",
                          onBlur: ($event: any) => (onBlur(item))
                        }, null, 8, ["value", "onUpdate:value", "onBlur"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_svg_icon, {
                      "icon-class": "content_live_edit",
                      class: "gird_item_icon",
                      onClick: ($event: any) => (clickShowInput(item))
                    }, null, 8, ["onClick"])
                  ])
                ])
              ], 10, _hoisted_28))
            }), 128))
          ]),
          (PcTemplateList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_a_empty, {
                  class: "empty_wrap",
                  image: _unref(emptyDataSec),
                  description: "页面暂无数据信息~"
                }, null, 8, ["image"])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_vShow, meauKey.value === 2],
          [_directive_infinite_scroll, scrollEventPc]
        ]),
        _createElementVNode("div", _hoisted_42, [
          (meauKey.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createVNode(_component_a_button, {
                  class: "worp_right_btn_nav",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (saveLibrary()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("存储为模板")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(clickStyle)()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_unref(aCheckbox), {
                      checked: selectAll.value,
                      "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((selectAll).value = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (changeItemMarkAll()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全选")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    danger: "",
                    class: "mod_btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (openDelModal(2))),
                    disabled: _unref(getSelected)
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_btn_icon",
                        "icon-class": "del"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(clickStyle)()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  })
                ])
              ]))
        ])
      ])
    ]),
    _createVNode(_unref(aModal), {
      visible: createModal.visible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((createModal.visible) = $event)),
      title: createModal.title,
      centered: "",
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createTextVNode("模板名称："),
          _createVNode(_component_a_input, {
            value: librartName.value,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((librartName).value = $event)),
            placeholder: "请输入内容",
            class: "model_box_in"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModalVue, {
      visible: delModal.visible,
      centered: true,
      loading: delModal.loading,
      close: closeDelModal,
      ok: delClick
    }, null, 8, ["visible", "loading"]),
    _createVNode(CDelModalVue, {
      visible: deletes.value,
      centered: "",
      close: openDeletes,
      ok: ConfirmDelete
    }, {
      title: _withCtx(() => [
        _createTextVNode("该操作将覆盖所有子直播间的该项配置，是否继续？")
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})